import { TextProps } from 'react-native'
import { ImageUrlDetection } from '../../utils/utils'
import { Box } from '../BoxNew'
import { Icon, IconIds } from '../IconNew'
import { Image } from '../ImageNew'
import { TextInput } from '../TextInputNew'
import { Text } from '../TextNew'
import styles from './styles'
import { ItemPositionType, ListData, ListItemProps, ListItemSelectableType, ListItemType } from './types'

export interface ListFooterData {
  text: string
  subTitle?: string
}
export const isURLFontIcon = (url: string): object => {
  const retData = {
    isFontIcon: false,
    iconId: '',
  }
  const icons = Object.keys(IconIds)
  icons.forEach((icon) => {
    if (IconIds[icon as keyof typeof IconIds] === url) {
      retData.iconId = icon
      retData.isFontIcon = true
    }
  })
  return retData
}

const getImageContainer = (type: ListItemType, data: ListData) => {
  if (!data.image) {
    return null
  }

  const iconInfo: any = isURLFontIcon(data.image)
  if (iconInfo.isFontIcon) {
    return (
      <Box {...styles[type].imageContainerStyle}>
        <Icon id={iconInfo.iconId as any} color="PRIMARY" size="FONT_SIZE_EXTRA_LARGE" />
      </Box>
    )
  }
  return (
    <Box {...styles[type].imageContainerStyle}>
      <Image {...styles[type].imageStyle} source={ImageUrlDetection(data.image)} />
    </Box>
  )
}

const getCounterComponent = (type: ListItemType, counterValue?: (count: number) => void, max?: number) => {
  return (
    <Box {...styles[type].selectableCounterStyle}>
      <Text>
        Counter Comp {counterValue} Max Value {max}
      </Text>
      {/* <Counter
        max={max}
        onPress={(value: any) => {
          if (counterValue) {
            counterValue(value)
          }
        }}
      /> */}
    </Box>
  )
}

const getSelectableContainer = (
  type: ListItemType,
  selectableType: ListItemSelectableType,
  counterValue?: (count: number) => void,
  selected?: boolean,
  counterMax?: number,
) => {
  let iconId
  if (selectableType === ListItemSelectableType.CHECKBOX) {
    iconId = selected ? 'CHECKBOX_CHECKED' : 'CHECKBOX_UNCHECKED'
  } else if (selectableType === ListItemSelectableType.RADIOBUTTON) {
    iconId = selected ? 'RADIOBUTTON_ON' : 'RADIOBUTTON_OFF'
  } else if (selectableType === ListItemSelectableType.TICKMARK && selected) {
    iconId = 'TICKMARK'
  } else if (selectableType === ListItemSelectableType.COUNTER) {
    return getCounterComponent(type, counterValue, counterMax)
  } else if (selectableType === ListItemSelectableType.ADDITEM) {
    iconId = 'INCREMENT'
  } else if (selectableType === ListItemSelectableType.RIGHT_ARROW) {
    iconId = 'ARROW_RIGHT'
  } else {
    return null
  }

  const colorTheme = () => {
    let colTheme = 'BLACK'
    switch (selectableType) {
      case ListItemSelectableType.RIGHT_ARROW:
        colTheme = 'BLACK'
        break
      case ListItemSelectableType.TICKMARK:
        colTheme = 'GREEN'
        break
      case ListItemSelectableType.ADDITEM:
        colTheme = 'PRIMARY_GREY'
        break
      default:
        colTheme = 'PRIMARY'
        break
    }
    return colTheme
  }

  const iconSize = () => {
    let size = 'FONT_SIZE_EXTRA_LONG'

    switch (selectableType) {
      case ListItemSelectableType.ADDITEM:
        size = 'FONT_SIZE_EXTRA_LONG'
        break
      case ListItemSelectableType.RIGHT_ARROW:
        size = 'FONT_SIZE_LARGE_PLUS'
        break
      default:
        size = 'FONT_SIZE_EXTRA_LARGE'
        break
    }
    return size
  }
  return (
    <Box {...styles[type].selectableContainerStyle}>
      <Icon id={iconId as any} color={colorTheme() as any} size={iconSize() as any} />
    </Box>
  )
}

const getContentContainer = (
  type: ListItemType,
  data: ListData,
  imagePosition: ItemPositionType,
  selected?: boolean,
  onChangeText?: (text: string) => void,
) => {
  const titleTextStyle: any =
    selected && styles[type].selectedTitleTextStyle ? styles[type].selectedTitleTextStyle : styles[type].titleTextStyle

  return (
    <Box {...styles[type].superContainerStyle}>
      <Box {...styles[type].contentContainerStyle}>
        <Box {...styles[type].subContent1ContainerStyle}>
          {data.text && imagePosition !== ItemPositionType.BACKGROUND && <Text {...titleTextStyle} title={data.text} />}
          {type === 'AddressLine' && (
            <>
              {data.type && <Text {...styles[type].titleTextStyle} title={data.type} />}
              {data.addressLine1 && <Text {...styles[type].value1TextStyle} title={data?.addressLine1 ?? ''} />}
              {!!data.addressLine2 && <Text {...styles[type].value1TextStyle} title={data?.addressLine2 ?? ''} />}
              {data.city && <Text {...styles[type].value1TextStyle} title={data?.city?.name ?? ''} />}
              {data.state && data.pincode && (
                <Text {...styles[type].value1TextStyle} title={`${data.state.name} - ${data.pincode}`} />
              )}
            </>
          )}

          {data.value && <Text {...styles[type].valueTextStyle} title={data.value} />}
          {data.value1 && <Text {...styles[type].value1TextStyle} title={data.value1} />}
          {data.value2 && <Text {...styles[type].value2TextStyle} title={data.value2} />}
          {data.value5 && <Text {...styles[type].value5TextStyle} title={data.value5} />}
        </Box>

        {data.value3 && data.value4 && (
          <Box {...styles[type].subContent2ContainerStyle}>
            {data.value3 && <Text {...styles[type].value3TextStyle} title={data.value3} />}
            {data.value4 && <Text {...styles[type].value4TextStyle} title={data.value4} />}
            {data.value6 && <Text {...styles[type].value6TextStyle} title={data.value6} />}
          </Box>
        )}
      </Box>
      <>
        {type === 'TwoLabelTwoValue' && selected && (
          <Box {...styles[type].bottomContainerStyle}>
            <TextInput
              type="body14"
              label="CVV"
              maxLength={3}
              onChangeText={onChangeText}
              rightIcon="DEFAULT_CARD"
              keyboardType="number-pad"
              secureTextEntry
              autoFocus
            />
          </Box>
        )}
      </>
      <>
        {type === 'TwoLabelTwoValueWithErrorInfo' && data.erorrLabel !== ' ' && (
          <Box {...styles[type].bottomContainerStyle}>
            {data.erorrLabel && <Text {...styles[type].errorLabelViewStyle} title={data.erorrLabel} />}
          </Box>
        )}
      </>
    </Box>
  )
}

const ListItem = (props: ListItemProps) => {
  const {
    key,
    type = ListItemType.DEFAULT,
    data,
    onPress,
    imagePosition = ItemPositionType.LEFT,
    selectableType = ListItemSelectableType.NONE,
    selectablePosition = ItemPositionType.RIGHT,
    selected,
    counterValue,
    onChangeText,
    counterMax = 0,
    overlayColor = 'GREY_SEPARATOR',
  } = props

  const containerStyle =
    selected && styles[type].selectedContainerStyle ? styles[type].selectedContainerStyle : styles[type].containerStyle
  return (
    <Box {...containerStyle} key={key} onPress={onPress} underlayColor={overlayColor as any}>
      <>
        {imagePosition === ItemPositionType.BACKGROUND && data.image && (
          <Image {...styles[type].imageStyle} source={data.image} resizeMode="center" />
        )}
        {selectablePosition === ItemPositionType.LEFT &&
          getSelectableContainer(type, selectableType, counterValue, selected, counterMax)}
        {imagePosition === ItemPositionType.LEFT && getImageContainer(type, data)}
        {type !== 'SmallImages' && getContentContainer(type, data, imagePosition, selected, onChangeText)}
        {selectablePosition === ItemPositionType.RIGHT &&
          getSelectableContainer(type, selectableType, counterValue, selected, counterMax)}
        {imagePosition === ItemPositionType.RIGHT && getImageContainer(type, data)}
        {data.text && imagePosition === ItemPositionType.BACKGROUND && type !== ListItemType.IMAGEDESC && (
          <Text {...(styles[type].titleTextStyle as TextProps)} numberOfLines={2} title={data.text} />
        )}
        {data.text && imagePosition === ItemPositionType.BACKGROUND && type === ListItemType.IMAGEDESC && (
          <Box {...styles[type].titleTextStyle}>
            <Text>
              Title :{data.text} Subtitle : {data?.subtitle ?? ''}{' '}
            </Text>
            {/* <TextLayout
              type={TextLayoutTypes.SHORT_TITLE}
              data={{ title: data.text, subTitle: data?.subtitle ?? '' }}
              colorTheme={TextLayoutColorTheme.WHITETITLE}
            /> */}
          </Box>
        )}
      </>
    </Box>
  )
}

export { ListItem, ListItemType, ItemPositionType, ListItemSelectableType }
export type { ListData }
